import { SET_AUTH_REDUCER } from "../types/authTypes";

export const setAuthReducer = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_AUTH_REDUCER,
      payload: data,
    });
  };
};
